export default __webpack_public_path__ + "static/media/card-medication-icon.d971e7fe.svg";